import type { PickerProps } from './types';

const OPTIONS = [
  'no-referrer',
  'no-referrer-when-downgrade',
  'origin',
  'origin-when-cross-origin',
  'same-origin',
  'strict-origin',
  'strict-origin-when-cross-origin',
  'unsafe-url',
];

export function ReferrerPolicyPicker({ value, onChange }: PickerProps) {
  return (
    <div className="picker-row">
      <select value={value} onChange={(e) => onChange(e.target.value)}>
        {!OPTIONS.includes(value) && <option value={value}>{value}</option>}
        {OPTIONS.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
    </div>
  );
}
